import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/combo_screenshot_sdy2z7_c_scale,w_2496.png'


const _hoisted_1 = { class: "hero bg-base-200" }
const _hoisted_2 = { class: "hero-content text-center flex-col" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "lg:px-24" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "\n              my-3\n              font-bold\n              text-5xl text-indigo-300\n              md:text-6xl\n              lg:text-7xl\n            " }, " STEAMplug CS "),
  /*#__PURE__*/_createElementVNode("p", { class: "my-8 text-xl md:text-2xl lg:text-4xl" }, " The one-stop shop for Computer Science courses. ")
], -1)
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "flex justify-center px-0 py-0" }
const _hoisted_7 = ["srcset"]

import SectionList from "@/components/CoursewareHero/SectionList.vue";
import GetInTouchCard from "@/components/CoursewareHero/GetInTouchCard.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("picture", null, [
              _createElementVNode("img", {
                class: "w-full",
                sizes: "(max-width: 2496px) 100vw, 2496px",
                srcset: 
                  (require('@/assets/combo_screenshot_sdy2z7_c_scale,w_320.png') +
                    '    320w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_683.png') +
                    '    683w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_945.png') +
                    '    945w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_1196.png') +
                    '  1196w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_1363.png') +
                    '  1363w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_1636.png') +
                    '  1636w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_1649.png') +
                    '  1649w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_1725.png') +
                    '  1725w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_1867.png') +
                    '  1867w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_1971.png') +
                    '  1971w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_2132.png') +
                    '  2132w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_2135.png') +
                    '  2135w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_2202.png') +
                    '  2202w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_2469.png') +
                    '  2469w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_2406.png') +
                    '  2406w',
                  require('@/assets/combo_screenshot_sdy2z7_c_scale,w_2496.png') +
                    '  2496w')
                ,
                src: _imports_0,
                alt: ""
              }, null, 8, _hoisted_7)
            ])
          ])
        ])
      ]),
      _createVNode(SectionList, { class: "px-0 md:px-2" }),
      _createVNode(GetInTouchCard, { class: "my-6 md:px-2" })
    ])
  ]))
}
}

})